import React, { useRef, useState } from 'react';
import { isAuthenticated } from '../../auth/index';
import { bulkUploadMemberships } from '../../features/memberships/helper/api';
import Toast from "../../lib/toast";
import { startLoader, stopLoader } from '../../lib/utils';
import { bulkUploadEnquiries } from '../../features/enquiry/helper/api';


const BulkUpload = (props) => {

  const [selectedBulkUploadType, setSelectedBulkUploadType] = useState("memberships");
  const [isButtonLock, setButtonLock] = useState(true);
  const {user,token} = isAuthenticated();
  const [choosedFile,setChoosedFile] = useState(null);



  const handleFile = event =>{
    let file = event?.target?.files?.[0];
    setChoosedFile(file);
    setButtonLock(false)
  }

  const toggleSwitchBulkUploadType = (uploadType) => {
    setSelectedBulkUploadType(uploadType);
  }

  const BulkUploadMemberships = async () =>{
    try{
      await startLoader()
      const formData = new FormData();
      const branchId = localStorage.getItem("branchId")
      setButtonLock(true);


      formData.set("file",choosedFile);

      const response = await bulkUploadMemberships(user._id,token,branchId,formData);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Error while uploading file."
        })
      }else{
          new Toast({
          type:"success",
          duration:3000,
          message:"File uploaded successfully."
        })
      }
    }catch(error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Error while uploading file."
        })
    }
    await stopLoader()
    setButtonLock(false);
  }



  const BulkUploadEnquiries = async () =>{
    try{
      await startLoader()
      const formData = new FormData();
      const branchId = localStorage.getItem("branchId")
      setButtonLock(true);


      formData.set("file",choosedFile);

      const response = await bulkUploadEnquiries(user._id,token,branchId,formData);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Error while uploading file."
        })
      }else{
          new Toast({
          type:"success",
          duration:3000,
          message:"File uploaded successfully."
        })
      }
    }catch(error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Error while uploading file."
        })
    }
    await stopLoader()
    setButtonLock(false);
  }

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item" style={{width: window.innerWidth > 767 && "30%", height: window.innerWidth > 767 && "70%", }}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <p className="flex-item fs-18 color-white">Bulk Upload</p>
              </div>
              <div onClick={props.toggleBulkUpload} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
         
        <div className='w-full' style={{padding:"12px", height:"95%"}}>
          <div className='d-flex flex-item m-b-12'>
         
            <div onClick={()=>toggleSwitchBulkUploadType("memberships")} className={`flex-item d-flex global-button-container m-r-12 ${selectedBulkUploadType == "memberships" && "global-button-container-active"}`}>
              <p className='flex-item'>Memberships</p>
            </div>
               <div onClick={()=>toggleSwitchBulkUploadType("enquiries")} className={`flex-item d-flex global-button-container m-r-12 ${selectedBulkUploadType == "enquiries" && "global-button-container-active"}`}>
              <p className='flex-item'>Enquiries</p>
            </div>
            {/* <div onClick={()=>toggleSwitchBulkUploadType("membership-plans")} className={`flex-item d-flex global-button-container ${selectedBulkUploadType == "membership-plans" && "global-button-container-active"}`}>
              <p className='flex-item'>Membership Plans</p>
            </div> */}
          </div>
          <div className='d-flex w-full m-b-20' style={{position:"relative", height:"50%", border:"1px dashed #9a9a9a", background:"#ffffff", borderRadius:"20px"}}>
            <div className='flex-item margin-auto'>
              <div className='w-full d-flex'>
                <svg className='flex-item margin-auto' width="50" height="50" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 2.13C2.5 1.36 3.36 0.5 4.12 0.5H13.88C14.64 0.5 15.5 1.36 15.5 2.13V11.88C15.5 12.64 14.64 13.5 13.88 13.5H4.13C3.36 13.5 2.5 12.64 2.5 11.88M0.5 4.5L4.5 9.5M4.5 4.5L0.5 9.5" stroke="#A6DA95" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.5 4.5V9.5M7.5 6.5H12.5M7.5 4.5H12.5V9.5H7.5V4.5Z" stroke="#A6DA95" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p className='flex-item margin-auto m-t-12 font-weight-600'>{choosedFile?`${choosedFile.name}`:"Upload Excel file"}</p>
            </div>
            <input onInput={handleFile} className='flex-item w-full h-full cursor-pointer' style={{position:"absolute", zIndex:4}} accept=".xls,.xlsx,.xlsm" type="file" />
          </div>
        </div>

        <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
          <div onClick={()=>selectedBulkUploadType == "memberships"?isButtonLock?null:BulkUploadMemberships():selectedBulkUploadType == "enquiries"?isButtonLock?null:BulkUploadEnquiries():alert(`This feature is currently under development. Our team will notify you as soon as it’s live.\nWe apologize for any inconvenience caused and appreciate your patience.`)} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
            <p className="flex-item">Upload</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulkUpload;